class BookmarkButton
    constructor: (el) ->
        @.$el = el

        @.active = @.$el.classList.contains 'icon-bookmark-marked-before'
        @.disabled = @.$el.classList.contains('bookmark-button--disabled') || @.$el.disabled
        @.text = @.$el.dataset?.text ? 'Beitrag merken'
        @.textActive = @.$el.dataset?.textActive ? 'Beitrag nicht mehr merken'

        @.InitEvents()
        @.$el.classList.add 'bookmark-button--bound'
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            if !self.disabled
                self.SetState !self.active
                self.$el.dispatchEvent new CustomEvent 'bookmark-button-state', {
                    bubbles: false,
                    detail: {
                        active: self.active
                    }
                }
            return
        return

    SetState: (active) ->
        if active
            @.active = true
            @.$el.textContent = @.textActive
            @.$el.classList.remove 'icon-bookmark-before'
            @.$el.classList.add 'icon-bookmark-marked-before'
        else
            @.active = false
            @.$el.textContent = @.text
            @.$el.classList.remove 'icon-bookmark-marked-before'
            @.$el.classList.add 'icon-bookmark-before'
        return

BindBookmarkButtons = ->
    document.querySelectorAll '.bookmark-button:not(.bookmark-button--bound)'
        .forEach (el) ->
            new BookmarkButton el
            return
    return

window.addEventListener 'bind-components', BindBookmarkButtons

class BookmarkButtonCreate
    constructor: (options) ->
        @.$el = null

        @.options = options ? {}

        @.CreateElement()
        if !@.options?.bindLater
            new BookmarkButton @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.options?.tag ? 'button'
        @.$el.classList.add 'bookmark-button', (if @.options?.active then 'icon-bookmark-marked-before' else 'icon-bookmark-before')
        if @.options.attrs
            @.$el = window.appUtils.Attributes @.options.attrs, @.$el
        @.$el.dataset.text = @.options?.text ? 'Beitrag merken'
        @.$el.dataset.textActive = @.options?.textActive ? 'Beitrag nicht mehr merken'
        if @.options?.tag == 'a'
            @.$el.href = @.options?.link ? "#"
        @.$el.textContent = if @.options?.active then @.$el.dataset.textActive else @.$el.dataset.text
        return

window.CreateBookmarkButton = (options) ->
    return new BookmarkButtonCreate options